import React from 'react';
import './index.css'
import { LandingPage } from '../../components/LandingPage';

export default function MainDescription() {
    return (
        <LandingPage />
    );
};